import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimationHackEffect from './animation_hack.js';

const AnimationLink = ({targetId, to, dataValue, faIcon, onMouseEnter, onMouseLeave, isExternal  }) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
        setIsAnimating(true);
        if (onMouseEnter) {
          onMouseEnter();
        }
    };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

    if (isExternal) {
        //external links
        return (
            <div className='papercactus__socials-social_link'
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <a
                    href={to} //href for external 
                >
                    <i className={faIcon}></i>&nbsp;
                </a>
                <a
                    id={targetId}
                    href={to} //href for external 
                    className='papercactus__socials-social_icon'
                >
                    {dataValue}
                    <AnimationHackEffect
                        targetElementId={targetId}
                        dataValue={dataValue}
                        isAnimating={isAnimating}
                        setIsAnimating={setIsAnimating}
                    />
                </a>
            </div>

            );
        }
        //internal links
        return (
            <div className='papercactus__socials-social_link'
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Link
                    to={to}
                >
                    <i className={faIcon}></i>&nbsp;
                </Link>
                <Link
                    id= {targetId}
                    data-value={dataValue}
                    className='papercactus__socials-social_icon'
                    to={to}
                >
                    {dataValue}
                    <AnimationHackEffect
                        targetElementId={targetId}
                        dataValue={dataValue}
                        isAnimating={isAnimating}
                        setIsAnimating={setIsAnimating}
                    />
                </Link>
            </div>
        );
};

export default AnimationLink;